
import Vue from 'vue'
import * as Froala from '@/services/FroalaHelpers'

export default Vue.extend({
   name: 'HtmlEditor',
   props: {
      id: { type: String, default: '' },
      value: { type: String, required: true },
      placeholder: { type: String, default: '' },
      allowVideo: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
   },
   data() {
      return {
         initialValue: '',
         innerValue: '',
      }
   },
   computed: {
      config(): any {
         const toolbarButtons = Froala.defaultToolbarButtons
         const plugins = Froala.defaultPlugins
         // if (this.allowVideo) {
         //    toolbarButtons = Froala.toolbarButtonsWithVideo
         //    plugins = Froala.pluginsWithVideo
         // }

         const options = {
            toolbarButtonsXS: toolbarButtons,
            toolbarButtonsSM: toolbarButtons,
            toolbarButtonsMD: toolbarButtons,
            toolbarButtons,
            // specialCharactersSets: Froala.specialCharactersSets,
            pluginsEnabled: plugins,
            fontFamily: Froala.defaultFonts,
            placeholderText: this.placeholder ? this.placeholder : 'Type Something',
            theme: 'gray',
            heightMin: 200,
            iframe: false,
            iframeStyleFiles: [
               '/lib/froala-editor/css/froala_style.css',
               '/css/htmleditor.css',
            ],
            tableInsertMaxSize: 6,
            fontFamilySelection: true,
            fontSizeSelection: true,
            colorsHEXInput: false,
            toolbarSticky: false,
            linkList: [],
            linkAlwaysBlank: true,
            linkStyles: [],
            linkInsertButtons: ['linkBack'],
            linkEditButtons: ['linkOpen', 'linkEdit', 'linkRemove'],
            imageUploadURL: '/api/ImageApi/Upload',
            key: null,
         }
         if ((window as any).froala_activation_key) {
            options.key = (window as any).froala_activation_key
         }
         return options
      },
   },
   mounted() {
      if (this.value) {
         this.innerValue = this.value
         this.initialValue = this.value
      }
   },
   watch: {
      value(newValue: string) {
         // Update our inner value if the bind source data changes
         if (this.innerValue !== newValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
      innerValue(event: any) {
         this.$emit('input', this.innerValue)
         this.$emit('change', this.innerValue)
      },
   },
})
